module.exports = __webpack_public_path__ + "img/icons_coins.33290ea9.svg";